import { Path, Svg } from '@react-pdf/renderer';
const PdfSiMonitor = () => (
  <Svg width="50" height="50" viewBox="0 0 24 24">
    <Path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H17.25C18.3546 4.75 19.25 5.64543 19.25 6.75V14.25C19.25 15.3546 18.3546 16.25 17.25 16.25H6.75C5.64543 16.25 4.75 15.3546 4.75 14.25V6.75Z"
    />
    <Path stroke="currentColor" strokeLinejoin="round" strokeWidth={2} d="M15.25 19.25L12 17.25L8.75 19.25" />
  </Svg>
);
export default PdfSiMonitor;
